<app-admin-header></app-admin-header>

<div class="container">
  <app-admin-sidebar></app-admin-sidebar>

  <!-- 🔹 Top Flex Container -->
<div class="patients-header">
  <h2>👥 Manage Patients</h2>

  <div class="action-buttons">
    <button (click)="showCompanyModal = true">➕ Add Company</button>
    <button (click)="showPatientModal = true">➕ Add Patient</button>
  </div>
</div>

<!-- 🔹 Feedback Toast -->
<div *ngIf="feedbackMessage" class="toast" [ngClass]="feedbackType">
  {{ feedbackMessage }}
</div>

  <!-- 🔹 Company Modal -->
  <div class="modal-backdrop" *ngIf="showCompanyModal">
    <div class="modal">
      <h3>Add New Company</h3>
      <input type="text" [(ngModel)]="newCompanyName" placeholder="Enter company name" />
      <div class="modal-actions">
        <button (click)="addCompany()">Save</button>
        <button class="cancel" (click)="showCompanyModal = false">Cancel</button>
      </div>
    </div>
  </div>

  <!-- 🔹 Patient Modal -->
  <div class="modal-backdrop" *ngIf="showPatientModal">
    <div class="modal large">
      <h3>{{ editingId ? 'Edit Patient' : 'Register Patient' }}</h3>
      <form (ngSubmit)="submit()" class="modal-form">
        <input type="text" placeholder="Surname" [(ngModel)]="form.surname" name="surname" required />
        <input type="text" placeholder="Other Names" [(ngModel)]="form.other_names" name="other_names" required />
        <input type="text" placeholder="Sex" [(ngModel)]="form.sex" name="sex" required />
        <input type="number" placeholder="Age" [(ngModel)]="form.age" name="age" required />
        <input type="text" placeholder="Hospital ID" [(ngModel)]="form.hospital_id" (blur)="checkHospitalIdUnique()" name="hospital_id" required />
        <input type="text" placeholder="Allergic (optional)" [(ngModel)]="form.allergic" name="allergic" />
        <input type="text" placeholder="Phone" [(ngModel)]="form.phone" name="phone" required />
        <input type="email" placeholder="Email" [(ngModel)]="form.email" name="email" required />

        <select [(ngModel)]="form.type" name="type" required>
          <option value="out-patient">Out-patient</option>
          <option value="in-patient">In-patient</option>
        </select>

        <select [(ngModel)]="form.company_id" name="company_id">
          <option [ngValue]="null">-- Select Company (optional) --</option>
          <option *ngFor="let company of companies" [ngValue]="company.id">{{ company.name }}</option>
        </select>

        <select [(ngModel)]="form.ward_id" name="ward_id" *ngIf="form.type === 'in-patient'" required>
          <option [ngValue]="null">-- Select Ward --</option>
          <option *ngFor="let ward of wards" [ngValue]="ward.id">{{ ward.name }}</option>
        </select>

        <div class="modal-actions">
          <button type="submit">{{ editingId ? 'Update' : 'Add' }}</button>
          <button class="cancel" type="button" (click)="resetForm(); showPatientModal = false">Cancel</button>
        </div>
      </form>
    </div>
  </div>

  <!-- 🔹 Search + Export + Import -->
<div class="actions">
  <input type="text" [(ngModel)]="searchTerm" placeholder="🔍 Search patients..." />
  <button (click)="exportToCSV()">📤 Export CSV</button>

  <!-- 🔄 Import Excel -->
  <label class="import-label">
    📥 Import Excel
    <input type="file" (change)="handleFileInput($event)" accept=".xlsx, .xls" hidden />
  </label>
</div>


  <!-- 🔹 Loading + Table -->
  <div *ngIf="loading">⏳ Loading patients...</div>

  <table class="patient-table" *ngIf="!loading">
  <thead>
    <tr>
      <th>Surname</th>
      <th>Other Names</th>
      <th>Sex</th>
      <th>Age</th>
      <th>Hospital ID</th>
      <th>Phone</th>
      <th>Email</th>
      <th>Type</th>
      <th>Ward</th>
      <th>Company</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let p of paginatedPatients; trackBy: trackById">
      <td>
        <span class="label">Surname:</span>
        <span class="value">{{ p.surname }}</span>
      </td>
      <td>
        <span class="label">Other Names:</span>
        <span class="value">{{ p.other_names }}</span>
      </td>
      <td>
        <span class="label">Sex:</span>
        <span class="value">{{ p.sex }}</span>
      </td>
      <td>
        <span class="label">Age:</span>
        <span class="value">{{ p.age }}</span>
      </td>
      <td>
        <span class="label">Hospital ID:</span>
        <span class="value">{{ p.hospital_id }}</span>
      </td>
      <td>
        <span class="label">Phone:</span>
        <span class="value">{{ p.phone }}</span>
      </td>
      <td>
        <span class="label">Email:</span>
        <span class="value">{{ p.email }}</span>
      </td>
      <td>
        <span class="label">Type:</span>
        <span class="value">{{ p.type }}</span>
      </td>
      <td>
        <span class="label">Ward:</span>
        <span class="value">{{ p.type === 'in-patient' ? getWardName(p.ward_id) : 'N/A' }}</span>
      </td>
      <td>
        <span class="label">Company:</span>
        <span class="value">{{ getCompanyName(p.company_id) }}</span>
      </td>
      <td class="actions">
        <button (click)="edit(p); showPatientModal = true;">✏️</button>
        <button (click)="delete(p.id)">🗑️</button>
        <button (click)="viewDetails(p.id)">🔍</button>
      </td>
    </tr>
  </tbody>
</table>


  <div class="pagination">
    <button (click)="currentPage = currentPage - 1" [disabled]="currentPage === 1">⬅️ Prev</button>
    <span>Page {{ currentPage }}</span>
    <button (click)="currentPage = currentPage + 1" [disabled]="currentPage * pageSize >= filteredPatients.length">Next ➡️</button>
  </div>
</div>

<!-- 🧾 Preview Import Modal -->
<div class="modal-backdrop" *ngIf="showPreview">
  <div class="modal large">
    <h3>📋 Preview Imported Patients</h3>
    <table class="preview-table" *ngIf="previewData.length">
      <thead>
        <tr>
          <th *ngFor="let key of previewData[0] | keyvalue">{{ key.key }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of previewData">
          <td *ngFor="let key of row | keyvalue">{{ key.value }}</td>
        </tr>
      </tbody>
    </table>

    <div class="modal-actions">
      <button (click)="confirmImport()">✅ Confirm Import</button>
      <button class="cancel" (click)="cancelImport()">❌ Cancel</button>
    </div>
  </div>
</div>

